import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { LandlordTermsQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type LandlordTerms = NonNullable<LandlordTermsQueryResult>;

const landlordTermsQuery = defineQuery(`*[
  _type == "landlordTerms" &&
  _id == "landlordTerms"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published landlord terms from Sanity. */
export const getLandlordTerms = createServerFn({ method: 'GET' }).handler(
  async (): Promise<LandlordTerms | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(landlordTermsQuery);
    } catch (error) {
      console.error('Failed to load Sanity landlord terms', error);
      return null;
    }
  },
);
